var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSessionReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_sessions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47656",
    "data-name": "Path 47656",
    d: "M5.5,7.981v7.654H1V7.981A.961.961,0,0,1,1.938,7H4.563A.961.961,0,0,1,5.5,7.981Z",
    transform: "translate(-.25 -3.859)",
    fill: "#00a1af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47657",
    "data-name": "Path 47657",
    d: "M13.5,3.981V14.776H9V3.981A.961.961,0,0,1,9.938,3h2.625A.961.961,0,0,1,13.5,3.981Z",
    transform: "translate(-2.25 -3)",
    fill: "#00a1af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47658",
    "data-name": "Path 47658",
    d: "M21.5,10.981v5.3H17v-5.3A.961.961,0,0,1,17.938,10h2.625A.961.961,0,0,1,21.5,10.981Z",
    transform: "translate(-4.25 -4.505)",
    fill: "#00a1af"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47659",
    "data-name": "Path 47659",
    d: "M17.438,20.547H.563a.525.525,0,1,1,0-1.047H17.438a.525.525,0,1,1,0,1.047Z",
    transform: "translate(0 -6.547)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSessionReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_session_report.cdf0d77b9b68bc3a76b2566ee92914cc.svg";